import React, { useCallback } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

import CustomTable from '../../components/CustomTable/CustomTable';
import CustomSortIcon from '../../components/CustomSortIcon/CustomSortIcon';
import { textSort } from '../../helpers/textSort';
import { Button, Tooltip } from 'antd';

import { ReactComponent as Eye } from '../../assets/eye-icon.svg';
import { ReactComponent as AccountIcon } from './img/account-icon.svg';
import { ReactComponent as DashboardIcon } from './img/dashboard-icon.svg';

const StatusColors = ({value, t}) => {
  
  const getStatusStyle = (value) => {
    if (value === 'NONE') return 'yellow';
    if (value === 'DONE') return 'green';
    if (value === 'PENDING') return 'red';
    return 'purple';
  };

  return (
    <span  className={`status-advisor ${getStatusStyle(value)}`}>{t(value)}</span>
  );
};

const AccountsTable = ({ accounts, isLoading, onboardingList }) => {
  const { t } = useTranslation('');
  const history = useHistory();

  const handlePortfoliosView = (accountId) => {
    console.log('View portfolios', accountId);
    history.push(`/accounts/${accountId}/portfolio`);
  };

  const handleAccountSettings = (accountId) => {
    console.log('View account', accountId);
    history.push(`/accounts/${accountId}/inform/details`);
  };

  const handleOnboardingView = (accountId) => {
    console.log('View onboarding', accountId);
    history.push(`/accounts/${accountId}/inform/onboarding`);
  };


  // PENDING, DONE, NONE

  const getStatus = useCallback((accountId) => {
    const onboardings = onboardingList?.filter(item => item.account_id === accountId);
    if (!onboardings?.length) return 'NONE';
    if (onboardings.every(e =>  e.status === 'COMPLETED' || e.status === 'CANCELED')) return 'DONE';
    // if (onboardings.some(e => e.status === 'pending')) return 'PENDING';
    return 'PENDING';
    
  }, [accounts, onboardingList]);

  const columns = [
    {
      title: t('CLIENT_NAME'),
      dataIndex: 'name',
      className: 'name',
      render: (value, record) => record?.company_name || value || '- - -',
      sorter: (a, b) =>
        textSort(a?.company_name || a?.name, b?.company_name || b?.name),
      sortIcon: (props) => <CustomSortIcon {...props} />,
      width: '20%',
    },
    {
      title: t('ACCOUNT_TYPE'),
      dataIndex: 'type',
      align: 'left',
      className: 'type',
      render: (value) =>
        value === 'private' ? t('PERSON') : t('ORGANIZATION'),
      sorter: (a, b) => textSort(a.type, b.type),
      sortIcon: (props) => <CustomSortIcon {...props} />,
      width: '',
    },
    {
      title: t('STATUS'),
      dataIndex: 'status',
      render: (value, record) => <StatusColors value={getStatus(record.id)} t={t} />,
      sorter: (a, b) => textSort(a.status, b.status),
      sortIcon: (props) => <CustomSortIcon {...props} />,
      width: '',
    },
    {
      title: t('EMAIL'),
      dataIndex: 'owner',
      render: (value) => value?.email || '- - -',
      sorter: (a, b) => textSort(a.email, b.email),
      sortIcon: (props) => <CustomSortIcon {...props} />,
      width: '',
    },
    {
      title: t('PHONE'),
      dataIndex: 'owner',
      render: (value) => (
              value?.phones?.map(
                (i) => (
                  <span key={uuidv4()} style={{ display: 'block', marginBottom: '3px' }}>
                    {i}
                  </span>
                )
              ) || ''
            ),
      sorter: (a, b) => textSort(a.phone, b.phone),
      sortIcon: (props) => <CustomSortIcon {...props} />,
      width: '',
    },
    {
      title: t('ACTIONS'),
      align: 'center',
      dataIndex: 'operation',
      className: 'operation',
      width: '',
      render: (_, record) => {
        return (
          <div className="cell-button-wrapper">
            <Button type="text" onClick={() => handlePortfoliosView(record.id)}>
              <Tooltip
                placement="top"
                title={
                  <span style={{ color: '#000000' }}>
                    {t('SHOW_PORTFOLIOS')}
                  </span>
                }
                color="white"
              >
                <Eye />
              </Tooltip>
            </Button>
            <Button
              type="text"
              onClick={() => handleAccountSettings(record.id)}
            >
              <Tooltip
                placement="top"
                title={
                  <span style={{ color: '#000000' }}>
                    {t('ACCOUNT_SETTINGS')}
                  </span>
                }
                color="white"
              >
                <AccountIcon />
              </Tooltip>
            </Button>
            <Button type="text" onClick={() => handleOnboardingView(record.id)}>
              <Tooltip
                placement="top"
                title={
                  <span style={{ color: '#000000' }}>
                    {t('ONBOARDING_VIEW')}
                  </span>
                }
                color="white"
              >
                <DashboardIcon />
              </Tooltip>
            </Button>
          </div>
        );
      },
    },
  ];
  return (
    <div
      style={{ padding: '24px' }}
      className="client portfolio-table instrument-table-wrapper"
    >
      <CustomTable
        rowKey={(record) => record.id}
        style={{ width: '100%' }}
        dataSource={accounts}
        columns={columns}
        size="middle"
        loading={isLoading}
        pagination={false}
      />
    </div>
  );
};

export default AccountsTable;

AccountsTable.propTypes = {
  accounts: PropTypes.array,
  isLoading: PropTypes.bool,
  onboardingList: PropTypes.array,
};

StatusColors.propTypes = {
  t: PropTypes.func,
  value: PropTypes.string,
};